<template>
  <div class="tsa-pagerV2">
        <!-- <h4 class="total">{{t('el.pager.total', { total: total })}}</h4> -->
        <div class="pages">
            <el-select v-model="pageSizesValue" placeholder="请选择" @change="change" v-if="selectRender">
                <el-option
                    v-for="item in pageSizes"
                        :key="item"
                        :label="item + t('el.pager.pagesize')"
                        :value="item">
                    </el-option>
            </el-select>
            <!-- <span class="iconStyle tsa-icon-select"></span> -->
        </div>
        <a class="pre iconStyle tsa-icon-arrow-left" @click="pre" :class="currentPage === 1 ? 'disabled' : ''" href="javascript:;"></a>
        <ul>
            <li v-for="(item, index) in pagesList" :key="index">
                <a :class="[currentPage === item ? 'active' : '', item === '...' ? 'normal' : '']" @click="pageChange(item)" href="javascript:;">{{ item }}</a>
            </li>
        </ul>
        <a class="next iconStyle tsa-icon-arrow-right" @click="next" :class="nextDisabled ? 'disabled' : ''" href="javascript:;"></a>
        <!-- <div class="jump">
            <p>{{t('el.pager.goto')}}</p>
            <div class="input-container">
                <input type="number" :value="jumpPageValue" min="1" :max="maxPage" @blur="blur($event)" @keydown.enter="blur($event)" ref="input">
                <p>{{ t('el.pager.pageClassifier') }}</p>
                <span class="iconStyle tsa-icon-select"></span>
            </div>
        </div> -->
  </div>
</template>

<script>
/* eslint-disable */
import Locale from 'tsa-ui/src/mixins/locale';
export default {
  name: 'TsaPager',
  props: {
        total: {
            type: Number,
            default: 0
        },
        currentPage: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 5
        },
        pageSizes: {
            type: Array,
            default: () => {
                return [10, 20, 30, 100]
            }
        }
    },
    data () {
        return {
            pageSizesValue: this.pageSizes[0],
            jumpPageValue: '1',
            selectRender: true,
        }
    },
    mixins: [Locale],
    watch: {
        currentPage (value) {
            this.jumpPageValue = value
        },
        pageSize: {
            handler (val) {
                this.selectRender = false
                setTimeout(() => {
                    this.selectRender = true
                    this.pageSizesValue = val
                })
            },
            immediate: true
        }
    },
    computed: {
        pagesList () {
            let pages = Math.ceil(this.total/this.pageSize)
            if (pages <= 5) return pages
            if (this.currentPage <=3) {
                return [1, 2, 3 ,'...', pages]
            }else if (this.currentPage >= pages - 1) {
                return [1, '...',pages-1, pages]
            }else{
                return [1, '...', this.currentPage,'...', pages]
            }
        },
        maxPage () {
            return this.total === 0 ? 1 : Math.ceil(this.total/this.pageSize)
        },
        nextDisabled () {
            let pages = Math.ceil(this.total/this.pageSize)
            if (this.currentPage === pages) {
                return true
            } else {
                return false
            }
        }
    },
    methods: {
        blur (e) {
            let value = e.target.value
            let newValue = parseInt(e.target.value)
            if (value) {
                if (this.jumpPageValue == newValue) return
                if (newValue > this.maxPage) {
                    newValue = this.maxPage
                } else if (newValue < 1) {
                    newValue = 1
                }
            } else {
                newValue = 1
            }
            // 强制清空
            this.$refs.input.value = newValue.toString()
            this.$emit('update:currentPage', newValue)
            this.$emit('current-change', newValue)
        },
        change () {
            this.$emit('update:currentPage', 1)
            this.$emit('size-change', this.pageSizesValue)
        },
        pageChange (item) {
            if (this.currentPage === item) return
            if (item === '...') return
            this.$emit('update:currentPage', item)
            this.$emit('current-change', item)
            
        },
        // 上一页面
        pre () {
            if (this.currentPage === 1) return
            let currentPage = this.currentPage - 1
            this.$emit('update:currentPage', currentPage)
            this.$emit('current-change', currentPage)
        },
        // 下一页面
        next () {
            if (this.nextDisabled) return
            let currentPage = this.currentPage + 1
            this.$emit('update:currentPage', currentPage)
            this.$emit('current-change', currentPage)
        }
    }
};
</script>
<style lang="scss" scoped>
    .tsa-pagerV2 {
        width: 100%;
        display: flex;
        justify-content: space-between;
        a {
            display: block;
            text-decoration: none;
        }
        display: flex;
        align-items: center;
        background-color: #FFFFFF;
        .total {
            margin-right: 10px;
            color: #666666;
            font-size: 14px;
            font-weight: normal;
        }
        ul {
            display: flex;
            align-items: center;
            list-style: none;
            li {
                margin-right: 4px;
                a {
                    padding: 0 7px;
                    border-radius: 4px;
                    color: #666666;
                    font-size: 14px;
                    line-height: 24px;
                    min-width: 24px;
                    box-sizing: border-box;
                    text-align: center;
                    &:hover {
                        color: #0047FF;
                    }
                    &.active {
                        color: #FFFFFF;
                        background-color: #0047FF;
                    }
                    &.normal {
                        cursor: default;
                    }
                }
                &:last-child {
                    margin-right: 10px;
                }
            }
        }
        .pre {
            border-radius: 4px;
            font-size: 24px;
            line-height: 24px;
            width: 24px;
            height: 24px;
            margin-right: 10px;
            color: #333333;
            &:hover {
                color: #FFFFFF;
                background-color: #1F5EFF;
            }
            &.disabled {
                cursor: not-allowed;
                color: #333333;
                &:hover {
                    background-color: #FFFFFF;
                }
            }
        }
        .next {
            border-radius: 4px;
            font-size: 24px;
            line-height: 24px;
            width: 24px;
            height: 24px;
            color: #333333;
            &:hover {
                color: #FFFFFF;
                background-color: #1F5EFF;
            }
            &.disabled {
                cursor: not-allowed;
                color: #333333;
                &:hover {
                    background-color: #FFFFFF;
                }
            }
        }
        .pages {
            display: flex;
            align-items: center;
            width: 100px;
            text-align: center;
            height: 24px;
            background-color: #F8F8F8;
            border-radius: 31px;
            margin-right: 4px;
            justify-content: flex-end;
            /deep/.el-select{
                .el-input {
                    width: 100%;
                    .el-input__inner {
                        width: 100%;
                        height: 32px;
                        line-height: 32px;
                        font-size: 14px;
                    }
                    .el-input__suffix{
                        .el-input__icon{
                            line-height: 32px;
                        }
                    }
                }
            }
            .iconStyle {
                padding: 0 4px;
                flex-shrink: 0;
                font-size: 20px;
                color: #999999;
            }
        }
        .jump {
            display: flex;
            align-items: center;
            > p {
                font-size: 14px;
                color: #666666;
                margin-right: 4px;
            }
            .input-container {
                display: flex;
                align-items: center;
                height: 24px;
                background-color: #F8F8F8;
                border-radius: 31px;
                padding-left: 12px;
                box-sizing: border-box;
                input {
                    // width: 86px;
                    font-size: 14px;
                    color: #666666;
                    text-align: center;
                    width: 40px;
                    background: transparent;
                    border: 0;
                    &:focus {
                        border: none;
                        outline: none;
                    }
                }
                input[type=number] {
                    -moz-appearance:textfield;
                }
                input[type=number]::-webkit-inner-spin-button,
                input[type=number]::-webkit-outer-spin-button {
                    -webkit-appearance: none;
                    margin:0 ;
                }
                p {
                    flex-shrink: 0;
                    font-size: 14px;
                    color: #666666;
                    flex: 1;
                    text-align: right;
                }
                .iconStyle {
                    padding: 0 4px;
                    flex-shrink: 0;
                    font-size: 20px;
                    color: #999999;
                }
            }
        }
    }

</style>
